import classNames from 'classnames';
import Frog from '../../assets/icon-jungle-frog.svg';
import Alien from '../../assets/icon-space-hatchling.svg';
import Kitten from '../../assets/icon-default-kitten.svg';
import Whizzy from '../../assets/icon-default-whizzy.svg';

interface StepperProps {
  steps: number;
  activeStep: number;
  showIcons?: boolean;
}

//Todo: Allow customisation of icons
const icons = {
  1: Frog,
  2: Alien,
  3: Kitten,
  4: Whizzy,
};

const iconCount = Object.keys(icons).length;

const Stepper = ({ steps, activeStep, showIcons = false }: StepperProps): JSX.Element => {

  const stepsArray = Array.from(Array(steps).keys());

  return (
    <ol className={`flex items-center m-md ${classNames({ 'mt-14': showIcons })}`}>
      {stepsArray.map((step) => {
        const stepNum = step + 1;
        const lastElement = stepNum === stepsArray.length;
        const isActive = stepNum <= activeStep;
        const isActiveBar = stepNum < activeStep;
        const icon = ((stepNum - 1) % iconCount) + 1;
        return (
          <li key={`stepper-${stepNum}`} className={`flex items-center ${classNames({ 'flex-grow': !lastElement })}`}>
            <span className={`flex items-center justify-center w-8 h-8 transition-colors border-2 border-white rounded-full lg:h-10 lg:w-10 shrink-0 font-bold ${classNames( { 'bg-positive text-white shadow-md': isActive, 'bg-gray-300 text-gray-800': !isActive })}`}>
              { showIcons && isActive ? <Icon icon={icon as IconProps['icon']} /> : null }
              {stepNum}
            </span>
            {!lastElement ? <span className={`flex-grow h-2 transition-colors border-b-2 border-t-2 border-white inline-block ${classNames({ 'bg-positive': isActiveBar, 'bg-gray-300': !isActiveBar })}`} /> : null }
          </li>);
      })}
    </ol>
  );
};

interface IconProps {
  icon: keyof typeof icons;
}

const Icon = ({ icon }: IconProps ): JSX.Element => {
  return (
    <img src={icons[icon]} className={'absolute h-12 mb-24 animate-pop'} />
  );
};

export default Stepper;
